import React from "react";
import { 
  FaCode, FaShieldAlt, FaBolt, FaPlug, 
  FaPuzzlePiece, FaWrench, FaSyncAlt, FaCheckCircle 
} from 'react-icons/fa';
import "./TallyPlatform.css";

function TallyPlatform() {
  return (
    <div className="platform-page-wrapper">
      {/* ── Hero Section ── */}
      <header className="platform-hero">
        <div className="platform-hero-content">
          <h1>Do More with Tally</h1>
          <p>
            Tally is designed to manage and simplify business processes through a
            robust ecosystem and integration, built by thousands of developers.
          </p>
        </div>
      </header>

      {/* ── Advantage Cards ── */}
      <section className="platform-advantages">
        <div className="advantage-card">
          <FaShieldAlt />
          <h3>Retain Tally's Power</h3>
          <p>Extensions and customizations retain the core features of Tally, so you never lose what makes Tally unique.</p>
        </div>
        <div className="advantage-card">
          <FaBolt />
          <h3>Rapid Development</h3>
          <p>Leverage the Tally Definition Language (TDL) for rapid creation and integration of business-specific solutions.</p>
        </div>
        <div className="advantage-card">
          <FaPlug />
          <h3>Plug and Play</h3>
          <p>Add extensions and use them instantly. Tally is built to adapt to your evolving business needs seamlessly.</p>
        </div>
      </section>

      {/* ── Extensions Section ── */}
      <section className="platform-module-section">
        <div className="platform-row">
          <div className="platform-text">
            <h2><FaPuzzlePiece /> Extensions</h2>
            <p>
              Expand TallyPrime across the TDL ecosystem. These extensions are designed 
              to cater to specific business requirements and enhance the overall TallyPrime experience.
            </p>
            <div className="platform-list">
              <ListItem text="Customization for specific needs" />
              <ListItem text="Scalable core functionality" />
              <ListItem text="Plug-and-play ease of use" />
              <ListItem text="Automated task efficiency" />
            </div>
          </div>
          <div className="platform-visual">
            <div className="visual-container">
              <img src="/images/tallynwq/image (1).png" alt="Tally Extensions" />
            </div>
          </div>
        </div>

        {/* ── Customization Section ── */}
        <div className="platform-row">
          <div className="platform-text">
            <h2><FaWrench /> Customization</h2>
            <p>
              Looking for tailored features? Custom solutions for Tally give you the tools 
              for your specific needs, allowing you to extend functionality and automate unique processes.
            </p>
            <div className="platform-list">
              <ListItem text="Industry-Specific Reports" />
              <ListItem text="Automated Workflows" />
              <ListItem text="User Roles & Permissions" />
              <ListItem text="Branded Invoices & Vouchers" />
            </div>
          </div>
          <div className="platform-visual">
            <div className="visual-container">
              <img src="/images/tallynwq/customise-your-tally.png" alt="Tally Customization" />
            </div>
          </div>
        </div>

        {/* ── Integrations Section ── */}
        <div className="platform-row">
          <div className="platform-text">
            <h2><FaSyncAlt /> Integrations</h2>
            <p>
              TallyPrime integrates third-party solutions seamlessly, giving you the
              flexibility to design and enhance your entire software ecosystem.
            </p>
            <div className="integrations-grid">
              <IntegrationCard 
                title="Payment Gateways"
                text="Connect with PayPal, Razorpay, or Stripe for automated reconciliation."
              />
              <IntegrationCard 
                title="CRM Systems"
                text="Sync with Salesforce or Zoho for seamless customer data flow."
              />
              <IntegrationCard 
                title="E-commerce"
                text="Integrate with Shopify, WooCommerce, or Magento effortlessly."
              />
              <IntegrationCard 
                title="Payroll"
                text="Simplify compliance with GreytHR or Zoho Payroll integration."
              />
            </div>
          </div>
          <div className="platform-visual">
            <div className="visual-container">
              <img src="/images/tallynwq/api-iIntegrations-with-tallyprime.webp" alt="Tally Integrations" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

const ListItem = ({ text }) => (
  <div className="platform-list-item">
    <FaCheckCircle />
    <span>{text}</span>
  </div>
);

const IntegrationCard = ({ title, text }) => (
  <div className="integration-card">
    <h4>{title}</h4>
    <p>{text}</p>
  </div>
);

export default TallyPlatform;
